// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d43a6e2f","643":"35bc3dd8","669":"3a4ddaec"}[chunkId] + ".chunk.js";
};